
export function getTodayDateAtNoon(): Date {
    const todayAtNoon = new Date(new Date().setHours(12, 0, 0, 0));
    return todayAtNoon
}

export function getFirstDayOfCurrentMonth(): Date {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    return firstDayOfMonth;
}
